window.WHAT_WE_TEST_DATA = {
  "settings": {
    "labels": {
      "includedBadge": "Included in ENGNE test",
      "testDetails": "Test details",
      "areaTested": "Area tested",
      "area": "Area",
      "focusGroup": "Focus group",
      "aboutListTitle": "Included tests",
      "detailsListTitle": "Area and focus"
    }
  },
  "sections": [
    {
      "title": "Vitamin & Mineral Panel",
      "id": "vitamin-and-mineral-panel",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Methylfolate (B9)"
            },
            {
              "title": "Betaine"
            },
            {
              "title": "Calcium"
            },
            {
              "title": "Choline"
            },
            {
              "title": "Cobalamin (Vitamin B12)"
            },
            {
              "title": "Magnesium"
            },
            {
              "title": "Methionine"
            },
            {
              "title": "Omega-3"
            },
            {
              "title": "Potassium"
            },
            {
              "title": "Riboflavin (Vitamin B2)"
            },
            {
              "title": "Selenium"
            },
            {
              "title": "Sodium"
            },
            {
              "title": "Vitamin A"
            },
            {
              "title": "Vitamin D"
            },
            {
              "title": "Vitamin E"
            },
            {
              "title": "Iron"
            }
          ]
        }
      ]
    },
    {
      "title": "Sleep",
      "id": "sleep",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Sleep Duration"
            },
            {
              "title": "Stress & Sleep"
            },
            {
              "title": "Trouble Getting to Sleep (Night Owl)"
            }
          ]
        }
      ]
    },
    {
      "title": "Intolerances & Sensitivities",
      "id": "intolerances-and-sensitivities",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Gluten Sensitivity"
            },
            {
              "title": "Fatty Food Sensitivity"
            },
            {
              "title": "Lactase Persistence in Adulthood"
            },
            {
              "title": "Lactose Intolerance"
            },
            {
              "title": "Hay Fever"
            },
            {
              "title": "Vitamin D and Allergies"
            }
          ]
        }
      ]
    },
    {
      "title": "Psychological Traits",
      "id": "psychological-traits",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Warrior vs Worrier"
            },
            {
              "title": "Brain Fog"
            },
            {
              "title": "Reward"
            },
            {
              "title": "Pessimist vs Optimist"
            },
            {
              "title": "Anger"
            },
            {
              "title": "Obsessiveness"
            },
            {
              "title": "Serotonin Panel"
            }
          ]
        }
      ]
    },
    {
      "title": "Anti-Ageing",
      "id": "anti-ageing",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Back Pain & Ageing"
            },
            {
              "title": "Cognitive Degeneration"
            },
            {
              "title": "Longevity"
            },
            {
              "title": "Metabolism"
            },
            {
              "title": "Stress and the Heart"
            }
          ]
        }
      ]
    },
    {
      "title": "Cardiac Health",
      "id": "cardiac-health",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Atrial Fibrillation"
            },
            {
              "title": "Cholesterol"
            },
            {
              "title": "Heart Disease"
            },
            {
              "title": "Hypertension"
            }
          ]
        }
      ]
    },
    {
      "title": "Diet",
      "id": "diet",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Fat Distribution"
            },
            {
              "title": "Likelihood to Snack"
            },
            {
              "title": "Metabolic Rate"
            },
            {
              "title": "Response to Protein"
            },
            {
              "title": "Response to Saturated Fat"
            },
            {
              "title": "Response to Sugar"
            },
            {
              "title": "Response to Unsaturated Fats"
            }
          ]
        }
      ]
    },
    {
      "title": "Health",
      "id": "health",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Caffeine Response"
            },
            {
              "title": "Fibromyalgia"
            },
            {
              "title": "Bone Mineral Density"
            },
            {
              "title": "Infection Risk"
            },
            {
              "title": "Obesity Risk"
            },
            {
              "title": "Gum Health"
            },
            {
              "title": "Lupus"
            },
            {
              "title": "Noise Induced Hearing Loss"
            },
            {
              "title": "PTPN22 Variant"
            },
            {
              "title": "Salt Sensitivity"
            },
            {
              "title": "Type 2 Diabetes"
            }
          ]
        }
      ]
    },
    {
      "title": "Immunity",
      "id": "immunity",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "B Vitamins & Immunity"
            },
            {
              "title": "Coeliac Disease"
            },
            {
              "title": "Immune Function"
            },
            {
              "title": "Inflammation"
            },
            {
              "title": "Selenium"
            },
            {
              "title": "Vitamin C"
            },
            {
              "title": "Vitamin D & Immunity"
            }
          ]
        }
      ]
    },
    {
      "title": "Injury",
      "id": "injury",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Achilles Tendinopathy"
            },
            {
              "title": "Lumbar Disc Disease"
            },
            {
              "title": "Physical Activity Response"
            },
            {
              "title": "Rehab Type"
            }
          ]
        }
      ]
    },
    {
      "title": "Kidney & Liver",
      "id": "kidney-and-liver",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Kidney Detoxification"
            },
            {
              "title": "Kidney Stone"
            },
            {
              "title": "Kidney Function"
            },
            {
              "title": "Alcohol response"
            },
            {
              "title": "Fat storage"
            },
            {
              "title": "metabolism (liver)"
            }
          ]
        }
      ]
    },
    {
      "title": "Lung Health",
      "id": "lung-health",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Asthma"
            },
            {
              "title": "Environmental Toxicity"
            },
            {
              "title": "Respiratory Tract Infections"
            },
            {
              "title": "Allergies and Vitamin D"
            }
          ]
        }
      ]
    },
    {
      "title": "Mental Health",
      "id": "mental-health",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Workaholic Tendency"
            },
            {
              "title": "Memory"
            }
          ]
        }
      ]
    },
    {
      "title": "Neuro Health",
      "id": "neuro-health",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Headaches"
            },
            {
              "title": "Neuropathy"
            },
            {
              "title": "Pain"
            },
            {
              "title": "Photosensitivity"
            }
          ]
        }
      ]
    },
    {
      "title": "Physical Performance",
      "id": "physical-performance",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Anaerobic Threshold"
            },
            {
              "title": "Best Time of Day to Exercise"
            },
            {
              "title": "Energy Recovery"
            },
            {
              "title": "Exercise Effect on Weight"
            },
            {
              "title": "Fasted vs Fed Exercise"
            },
            {
              "title": "Lean Body Mass"
            },
            {
              "title": "Muscle Fibre Type"
            },
            {
              "title": "Muscle Mass"
            },
            {
              "title": "Myostatin"
            },
            {
              "title": "Stress"
            }
          ]
        }
      ]
    },
    {
      "title": "Psychology",
      "id": "psychology",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Anger"
            },
            {
              "title": "Autism"
            },
            {
              "title": "Brain Fog"
            },
            {
              "title": "Intellect"
            },
            {
              "title": "Obsession"
            },
            {
              "title": "Optimism"
            },
            {
              "title": "Reward"
            },
            {
              "title": "Warrior vs Worrier"
            }
          ]
        }
      ]
    },
    {
      "title": "Skin",
      "id": "skin",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Dry Skin"
            },
            {
              "title": "Gluten Sensitivity"
            },
            {
              "title": "Wrinkles"
            },
            {
              "title": "Rosacea"
            },
            {
              "title": "Acne"
            }
          ]
        }
      ]
    },
    {
      "title": "Supplements",
      "id": "supplements",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "Ashwagandha"
            },
            {
              "title": "Curcumin"
            },
            {
              "title": "Essential Amino Acids"
            },
            {
              "title": "Epicatechin"
            },
            {
              "title": "Ginger"
            },
            {
              "title": "Glucosamine"
            },
            {
              "title": "Glutamine"
            },
            {
              "title": "HMB"
            },
            {
              "title": "Phosphatidic Acid"
            },
            {
              "title": "Taurine"
            },
            {
              "title": "Tribulus"
            },
            {
              "title": "Tyrosine"
            },
            {
              "title": "Whey Protein Digestion"
            }
          ]
        }
      ]
    },
    {
      "title": "Male Hormones",
      "id": "male-hormones",
      "badge": "DNA test, done once",
      "groups": [
        {
          "title": "Included DNA tests",
          "itemRefs": [
            {
              "title": "DHT & Prostate"
            },
            {
              "title": "FSH Range"
            },
            {
              "title": "Oestrogen"
            },
            {
              "title": "SHBG Range"
            },
            {
              "title": "Testosterone"
            }
          ]
        }
      ]
    },
    {
      "title": "Epigenetics",
      "id": "epigenetics",
      "badge": "Epigenetic test, repeatable",
      "groups": [
        {
          "title": "Repeatable epigenetic tests",
          "itemRefs": [
            {
              "title": "AlphaAge, Male Specific Biological DNA Methylation Test"
            },
            {
              "title": "Memory Age"
            },
            {
              "title": "Hearing Age"
            },
            {
              "title": "Eye Age"
            },
            {
              "title": "Epi Vitality"
            },
            {
              "title": "MethylGuard"
            }
          ]
        }
      ]
    }
  ],
  "meta": {
    "Vitamin & Mineral Panel": {
      "aboutTitle": "About vitamin & mineral panel",
      "aboutText": "ENGNE reviews key vitamin and mineral pathways that shape energy, recovery, immune defence, hormone function, and long term male performance.",
      "focus": "nutrient handling, methylation, energy production, and cellular function"
    },
    "Sleep": {
      "aboutTitle": "About sleep",
      "aboutText": "ENGNE sleep insights look at genetic patterns linked with sleep need, stress related disruption, and natural night time rhythm.",
      "focus": "sleep timing, recovery rhythm, and nervous system restoration"
    },
    "Intolerances & Sensitivities": {
      "aboutTitle": "About intolerances & sensitivities",
      "aboutText": "ENGNE intolerance insights help identify biological patterns linked with food response, digestion, allergy sensitivity, and inflammatory pressure.",
      "focus": "food sensitivity, immune response, and digestive tolerance"
    },
    "Psychological Traits": {
      "aboutTitle": "About psychological traits",
      "aboutText": "ENGNE psychological trait insights look at the biology behind pressure tolerance, motivation, emotional response, and cognitive style.",
      "focus": "focus, motivation, reward processing, and stress behaviour"
    },
    "Anti-Ageing": {
      "aboutTitle": "About anti-ageing",
      "aboutText": "ENGNE ageing insights connect DNA patterns with long term resilience, cognitive health, metabolic function, and heart related stress signals.",
      "focus": "healthy ageing, cognitive resilience, metabolism, and cardiovascular stress"
    },
    "Cardiac Health": {
      "aboutTitle": "About cardiac health",
      "aboutText": "ENGNE cardiac insights focus on inherited patterns linked with heart rhythm, cholesterol response, blood pressure, and vascular strain.",
      "focus": "cardiovascular resilience, blood pressure, lipids, and heart related risk"
    },
    "Diet": {
      "aboutTitle": "About diet",
      "aboutText": "ENGNE diet insights show how your body may respond to protein, fats, sugar, snacking behaviour, and metabolic rate.",
      "focus": "macronutrient response, appetite behaviour, metabolism, and body composition"
    },
    "Health": {
      "aboutTitle": "About health",
      "aboutText": "ENGNE health insights bring together broad DNA signals linked with resilience, inflammation, bone strength, caffeine response, and disease related risk.",
      "focus": "system resilience, inflammation, bone health, immunity, and metabolic risk"
    },
    "Immunity": {
      "aboutTitle": "About immunity",
      "aboutText": "ENGNE immunity insights look at the DNA pathways behind immune strength, inflammatory tone, vitamin support, and infection vulnerability.",
      "focus": "immune defence, inflammation control, nutrient support, and infection resilience"
    },
    "Injury": {
      "aboutTitle": "About injury",
      "aboutText": "ENGNE injury insights support smarter training decisions by reviewing DNA patterns linked with tissue load, recovery type, and injury vulnerability.",
      "focus": "tendon strength, disc resilience, exercise adaptation, and rehabilitation response"
    },
    "Kidney & Liver": {
      "aboutTitle": "About kidney & liver",
      "aboutText": "ENGNE kidney and liver insights look at biological pathways linked with detoxification, alcohol response, stone risk, and metabolic clearance.",
      "focus": "detoxification, metabolic clearance, fat handling, and organ resilience"
    },
    "Lung Health": {
      "aboutTitle": "About lung health",
      "aboutText": "ENGNE lung insights review DNA patterns tied to breathing resilience, asthma tendency, respiratory infection risk, and environmental sensitivity.",
      "focus": "airway sensitivity, respiratory resilience, toxicity response, and infection risk"
    },
    "Mental Health": {
      "aboutTitle": "About mental health",
      "aboutText": "ENGNE mental health insights look at biological signals linked with work drive, memory, stress load, and mental stamina.",
      "focus": "cognitive load, memory, stress drive, and daily mental resilience"
    },
    "Neuro Health": {
      "aboutTitle": "About neuro health",
      "aboutText": "ENGNE neuro health insights review DNA patterns connected with pain, headaches, neuropathy, photosensitivity, and nervous system load.",
      "focus": "nerve function, pain sensitivity, headaches, and sensory resilience"
    },
    "Physical Performance": {
      "aboutTitle": "About physical performance",
      "aboutText": "ENGNE physical performance insights connect DNA patterns with training adaptation, muscle fibre type, energy recovery, and exercise strategy.",
      "focus": "training response, energy recovery, muscle profile, and exercise timing"
    },
    "Psychology": {
      "aboutTitle": "About psychology",
      "aboutText": "ENGNE psychology insights help interpret genetic patterns linked with behaviour, reward, optimism, pressure response, and cognitive traits.",
      "focus": "behavioural tendencies, cognition, reward response, and emotional regulation"
    },
    "Skin": {
      "aboutTitle": "About skin",
      "aboutText": "ENGNE skin insights look at DNA patterns linked with dryness, acne, rosacea, wrinkles, gluten response, and visible ageing.",
      "focus": "skin barrier, inflammation, collagen ageing, and visible skin resilience"
    },
    "Supplements": {
      "aboutTitle": "About supplements",
      "aboutText": "ENGNE supplement insights help personalise support across performance, recovery, inflammation, protein digestion, and training adaptation.",
      "focus": "supplement response, muscle support, recovery biology, and nutrient strategy"
    },
    "Male Hormones": {
      "aboutTitle": "About male hormones",
      "aboutText": "ENGNE male hormone insights focus on DNA patterns linked with testosterone, DHT, SHBG, FSH, oestrogen balance, and prostate context.",
      "focus": "testosterone biology, androgen response, prostate context, and hormone balance"
    },
    "Epigenetics": {
      "aboutTitle": "About epigenetics",
      "aboutText": "ENGNE epigenetic testing tracks methylation based signals that can change over time. This area supports repeat measurement of biological age, vitality, and system specific ageing.",
      "focus": "biological age, methylation change, organ specific ageing, and repeatable tracking"
    }
  },
  "content": {
    "Vitamin & Mineral Panel": {
      "Included DNA tests": {
        "Methylfolate (B9)": {
          "copy": "Testing Methylfolate (B9) helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Betaine": {
          "copy": "Testing Betaine helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Calcium": {
          "copy": "Testing Calcium helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Choline": {
          "copy": "Testing Choline helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Cobalamin (Vitamin B12)": {
          "copy": "Testing Cobalamin (Vitamin B12) helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Magnesium": {
          "copy": "Testing Magnesium helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Methionine": {
          "copy": "Testing Methionine helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Omega-3": {
          "copy": "Testing Omega-3 helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Potassium": {
          "copy": "Testing Potassium helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Riboflavin (Vitamin B2)": {
          "copy": "Testing Riboflavin (Vitamin B2) helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Selenium": {
          "copy": "Testing Selenium helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Sodium": {
          "copy": "Testing Sodium helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Vitamin A": {
          "copy": "Testing Vitamin A helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Vitamin D": {
          "copy": "Testing Vitamin D helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Vitamin E": {
          "copy": "Testing Vitamin E helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        },
        "Iron": {
          "copy": "Testing Iron helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Vitamin & Mineral Panel",
          "group": "Vitamin & Mineral Panel",
          "badge": "DNA test, done once"
        }
      }
    },
    "Sleep": {
      "Included DNA tests": {
        "Sleep Duration": {
          "copy": "Testing Sleep Duration helps ENGNE read DNA signals linked with sleep rhythm, recovery timing, and nervous system restoration. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Sleep",
          "group": "Sleep",
          "badge": "DNA test, done once"
        },
        "Stress & Sleep": {
          "copy": "Testing Stress & Sleep helps ENGNE read DNA signals linked with sleep rhythm, recovery timing, and nervous system restoration. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Sleep",
          "group": "Sleep",
          "badge": "DNA test, done once"
        },
        "Trouble Getting to Sleep (Night Owl)": {
          "copy": "Testing Trouble Getting to Sleep (Night Owl) helps ENGNE read DNA signals linked with sleep rhythm, recovery timing, and nervous system restoration. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Sleep",
          "group": "Sleep",
          "badge": "DNA test, done once"
        }
      }
    },
    "Intolerances & Sensitivities": {
      "Included DNA tests": {
        "Gluten Sensitivity": {
          "copy": "Testing Gluten Sensitivity helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Intolerances & Sensitivities",
          "group": "Intolerances & Sensitivities",
          "badge": "DNA test, done once"
        },
        "Fatty Food Sensitivity": {
          "copy": "Testing Fatty Food Sensitivity helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Intolerances & Sensitivities",
          "group": "Intolerances & Sensitivities",
          "badge": "DNA test, done once"
        },
        "Lactase Persistence in Adulthood": {
          "copy": "Testing Lactase Persistence in Adulthood helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Intolerances & Sensitivities",
          "group": "Intolerances & Sensitivities",
          "badge": "DNA test, done once"
        },
        "Lactose Intolerance": {
          "copy": "Testing Lactose Intolerance helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Intolerances & Sensitivities",
          "group": "Intolerances & Sensitivities",
          "badge": "DNA test, done once"
        },
        "Hay Fever": {
          "copy": "Testing Hay Fever helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Intolerances & Sensitivities",
          "group": "Intolerances & Sensitivities",
          "badge": "DNA test, done once"
        },
        "Vitamin D and Allergies": {
          "copy": "Testing Vitamin D and Allergies helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Intolerances & Sensitivities",
          "group": "Intolerances & Sensitivities",
          "badge": "DNA test, done once"
        }
      }
    },
    "Psychological Traits": {
      "Included DNA tests": {
        "Warrior vs Worrier": {
          "copy": "Testing Warrior vs Worrier helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychological Traits",
          "group": "Psychological Traits",
          "badge": "DNA test, done once"
        },
        "Brain Fog": {
          "copy": "Testing Brain Fog helps ENGNE read DNA signals linked with nervous system function, mental clarity, and sensory resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychological Traits",
          "group": "Psychological Traits",
          "badge": "DNA test, done once"
        },
        "Reward": {
          "copy": "Testing Reward helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychological Traits",
          "group": "Psychological Traits",
          "badge": "DNA test, done once"
        },
        "Pessimist vs Optimist": {
          "copy": "Testing Pessimist vs Optimist helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychological Traits",
          "group": "Psychological Traits",
          "badge": "DNA test, done once"
        },
        "Anger": {
          "copy": "Testing Anger helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychological Traits",
          "group": "Psychological Traits",
          "badge": "DNA test, done once"
        },
        "Obsessiveness": {
          "copy": "Testing Obsessiveness helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychological Traits",
          "group": "Psychological Traits",
          "badge": "DNA test, done once"
        },
        "Serotonin Panel": {
          "copy": "Testing Serotonin Panel helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychological Traits",
          "group": "Psychological Traits",
          "badge": "DNA test, done once"
        }
      }
    },
    "Anti-Ageing": {
      "Included DNA tests": {
        "Back Pain & Ageing": {
          "copy": "Testing Back Pain & Ageing helps ENGNE read DNA signals linked with tissue resilience, load tolerance, and recovery strategy. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Anti-Ageing",
          "group": "Anti-Ageing",
          "badge": "DNA test, done once"
        },
        "Cognitive Degeneration": {
          "copy": "Testing Cognitive Degeneration helps ENGNE read DNA signals linked with nervous system function, mental clarity, and sensory resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Anti-Ageing",
          "group": "Anti-Ageing",
          "badge": "DNA test, done once"
        },
        "Longevity": {
          "copy": "Testing Longevity helps ENGNE read DNA signals linked with biological age, methylation status, repair capacity, and long term resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Anti-Ageing",
          "group": "Anti-Ageing",
          "badge": "DNA test, done once"
        },
        "Metabolism": {
          "copy": "Testing Metabolism helps ENGNE read DNA signals linked with biological age, methylation status, repair capacity, and long term resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Anti-Ageing",
          "group": "Anti-Ageing",
          "badge": "DNA test, done once"
        },
        "Stress and the Heart": {
          "copy": "Testing Stress and the Heart helps ENGNE read DNA signals linked with cardiovascular load, vascular resilience, and long term heart health. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Anti-Ageing",
          "group": "Anti-Ageing",
          "badge": "DNA test, done once"
        }
      }
    },
    "Cardiac Health": {
      "Included DNA tests": {
        "Atrial Fibrillation": {
          "copy": "Testing Atrial Fibrillation helps ENGNE read DNA signals linked with cardiovascular load, vascular resilience, and long term heart health. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Cardiac Health",
          "group": "Cardiac Health",
          "badge": "DNA test, done once"
        },
        "Cholesterol": {
          "copy": "Testing Cholesterol helps ENGNE read DNA signals linked with cardiovascular load, vascular resilience, and long term heart health. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Cardiac Health",
          "group": "Cardiac Health",
          "badge": "DNA test, done once"
        },
        "Heart Disease": {
          "copy": "Testing Heart Disease helps ENGNE read DNA signals linked with cardiovascular load, vascular resilience, and long term heart health. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Cardiac Health",
          "group": "Cardiac Health",
          "badge": "DNA test, done once"
        },
        "Hypertension": {
          "copy": "Testing Hypertension helps ENGNE read DNA signals linked with cardiovascular load, vascular resilience, and long term heart health. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Cardiac Health",
          "group": "Cardiac Health",
          "badge": "DNA test, done once"
        }
      }
    },
    "Diet": {
      "Included DNA tests": {
        "Fat Distribution": {
          "copy": "Testing Fat Distribution helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Diet",
          "group": "Diet",
          "badge": "DNA test, done once"
        },
        "Likelihood to Snack": {
          "copy": "Testing Likelihood to Snack helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Diet",
          "group": "Diet",
          "badge": "DNA test, done once"
        },
        "Metabolic Rate": {
          "copy": "Testing Metabolic Rate helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Diet",
          "group": "Diet",
          "badge": "DNA test, done once"
        },
        "Response to Protein": {
          "copy": "Testing Response to Protein helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Diet",
          "group": "Diet",
          "badge": "DNA test, done once"
        },
        "Response to Saturated Fat": {
          "copy": "Testing Response to Saturated Fat helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Diet",
          "group": "Diet",
          "badge": "DNA test, done once"
        },
        "Response to Sugar": {
          "copy": "Testing Response to Sugar helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Diet",
          "group": "Diet",
          "badge": "DNA test, done once"
        },
        "Response to Unsaturated Fats": {
          "copy": "Testing Response to Unsaturated Fats helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Diet",
          "group": "Diet",
          "badge": "DNA test, done once"
        }
      }
    },
    "Health": {
      "Included DNA tests": {
        "Caffeine Response": {
          "copy": "Testing Caffeine Response helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Fibromyalgia": {
          "copy": "Testing Fibromyalgia helps ENGNE read DNA signals linked with system resilience, inflammation, bone health, immunity, and metabolic risk. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Bone Mineral Density": {
          "copy": "Testing Bone Mineral Density helps ENGNE read DNA signals linked with tissue resilience, load tolerance, and recovery strategy. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Infection Risk": {
          "copy": "Testing Infection Risk helps ENGNE read DNA signals linked with system resilience, inflammation, bone health, immunity, and metabolic risk. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Obesity Risk": {
          "copy": "Testing Obesity Risk helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Gum Health": {
          "copy": "Testing Gum Health helps ENGNE read DNA signals linked with system resilience, inflammation, bone health, immunity, and metabolic risk. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Lupus": {
          "copy": "Testing Lupus helps ENGNE read DNA signals linked with system resilience, inflammation, bone health, immunity, and metabolic risk. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Noise Induced Hearing Loss": {
          "copy": "Testing Noise Induced Hearing Loss helps ENGNE read DNA signals linked with biological age, methylation status, repair capacity, and long term resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "PTPN22 Variant": {
          "copy": "Testing PTPN22 Variant helps ENGNE read DNA signals linked with system resilience, inflammation, bone health, immunity, and metabolic risk. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Salt Sensitivity": {
          "copy": "Testing Salt Sensitivity helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        },
        "Type 2 Diabetes": {
          "copy": "Testing Type 2 Diabetes helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Health",
          "group": "Health",
          "badge": "DNA test, done once"
        }
      }
    },
    "Immunity": {
      "Included DNA tests": {
        "B Vitamins & Immunity": {
          "copy": "Testing B Vitamins & Immunity helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Immunity",
          "group": "Immunity",
          "badge": "DNA test, done once"
        },
        "Coeliac Disease": {
          "copy": "Testing Coeliac Disease helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Immunity",
          "group": "Immunity",
          "badge": "DNA test, done once"
        },
        "Immune Function": {
          "copy": "Testing Immune Function helps ENGNE read DNA signals linked with immune defence, inflammation control, nutrient support, and infection resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Immunity",
          "group": "Immunity",
          "badge": "DNA test, done once"
        },
        "Inflammation": {
          "copy": "Testing Inflammation helps ENGNE read DNA signals linked with immune defence, inflammation control, nutrient support, and infection resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Immunity",
          "group": "Immunity",
          "badge": "DNA test, done once"
        },
        "Selenium": {
          "copy": "Testing Selenium helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Immunity",
          "group": "Immunity",
          "badge": "DNA test, done once"
        },
        "Vitamin C": {
          "copy": "Testing Vitamin C helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Immunity",
          "group": "Immunity",
          "badge": "DNA test, done once"
        },
        "Vitamin D & Immunity": {
          "copy": "Testing Vitamin D & Immunity helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Immunity",
          "group": "Immunity",
          "badge": "DNA test, done once"
        }
      }
    },
    "Injury": {
      "Included DNA tests": {
        "Achilles Tendinopathy": {
          "copy": "Testing Achilles Tendinopathy helps ENGNE read DNA signals linked with tissue resilience, load tolerance, and recovery strategy. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Injury",
          "group": "Injury",
          "badge": "DNA test, done once"
        },
        "Lumbar Disc Disease": {
          "copy": "Testing Lumbar Disc Disease helps ENGNE read DNA signals linked with tissue resilience, load tolerance, and recovery strategy. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Injury",
          "group": "Injury",
          "badge": "DNA test, done once"
        },
        "Physical Activity Response": {
          "copy": "Testing Physical Activity Response helps ENGNE read DNA signals linked with tissue resilience, load tolerance, and recovery strategy. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Injury",
          "group": "Injury",
          "badge": "DNA test, done once"
        },
        "Rehab Type": {
          "copy": "Testing Rehab Type helps ENGNE read DNA signals linked with tissue resilience, load tolerance, and recovery strategy. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Injury",
          "group": "Injury",
          "badge": "DNA test, done once"
        }
      }
    },
    "Kidney & Liver": {
      "Included DNA tests": {
        "Kidney Detoxification": {
          "copy": "Testing Kidney Detoxification helps ENGNE read DNA signals linked with clearance pathways, detoxification, and metabolic resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Kidney & Liver",
          "group": "Kidney & Liver",
          "badge": "DNA test, done once"
        },
        "Kidney Stone": {
          "copy": "Testing Kidney Stone helps ENGNE read DNA signals linked with clearance pathways, detoxification, and metabolic resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Kidney & Liver",
          "group": "Kidney & Liver",
          "badge": "DNA test, done once"
        },
        "Kidney Function": {
          "copy": "Testing Kidney Function helps ENGNE read DNA signals linked with clearance pathways, detoxification, and metabolic resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Kidney & Liver",
          "group": "Kidney & Liver",
          "badge": "DNA test, done once"
        },
        "Alcohol response": {
          "copy": "Testing Alcohol response helps ENGNE read DNA signals linked with clearance pathways, detoxification, and metabolic resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Kidney & Liver",
          "group": "Kidney & Liver",
          "badge": "DNA test, done once"
        },
        "Fat storage": {
          "copy": "Testing Fat storage helps ENGNE read DNA signals linked with fuel handling, appetite patterns, blood sugar balance, and body composition. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Kidney & Liver",
          "group": "Kidney & Liver",
          "badge": "DNA test, done once"
        },
        "metabolism (liver)": {
          "copy": "Testing metabolism (liver) helps ENGNE read DNA signals linked with clearance pathways, detoxification, and metabolic resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Kidney & Liver",
          "group": "Kidney & Liver",
          "badge": "DNA test, done once"
        }
      }
    },
    "Lung Health": {
      "Included DNA tests": {
        "Asthma": {
          "copy": "Testing Asthma helps ENGNE read DNA signals linked with airway response, respiratory resilience, and oxygen related performance. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Lung Health",
          "group": "Lung Health",
          "badge": "DNA test, done once"
        },
        "Environmental Toxicity": {
          "copy": "Testing Environmental Toxicity helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Lung Health",
          "group": "Lung Health",
          "badge": "DNA test, done once"
        },
        "Respiratory Tract Infections": {
          "copy": "Testing Respiratory Tract Infections helps ENGNE read DNA signals linked with airway response, respiratory resilience, and oxygen related performance. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Lung Health",
          "group": "Lung Health",
          "badge": "DNA test, done once"
        },
        "Allergies and Vitamin D": {
          "copy": "Testing Allergies and Vitamin D helps ENGNE read DNA signals linked with nutrient metabolism, methylation, energy support, and cellular function. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Lung Health",
          "group": "Lung Health",
          "badge": "DNA test, done once"
        }
      }
    },
    "Mental Health": {
      "Included DNA tests": {
        "Workaholic Tendency": {
          "copy": "Testing Workaholic Tendency helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Mental Health",
          "group": "Mental Health",
          "badge": "DNA test, done once"
        },
        "Memory": {
          "copy": "Testing Memory helps ENGNE read DNA signals linked with nervous system function, mental clarity, and sensory resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Mental Health",
          "group": "Mental Health",
          "badge": "DNA test, done once"
        }
      }
    },
    "Neuro Health": {
      "Included DNA tests": {
        "Headaches": {
          "copy": "Testing Headaches helps ENGNE read DNA signals linked with nervous system function, mental clarity, and sensory resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Neuro Health",
          "group": "Neuro Health",
          "badge": "DNA test, done once"
        },
        "Neuropathy": {
          "copy": "Testing Neuropathy helps ENGNE read DNA signals linked with nervous system function, mental clarity, and sensory resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Neuro Health",
          "group": "Neuro Health",
          "badge": "DNA test, done once"
        },
        "Pain": {
          "copy": "Testing Pain helps ENGNE read DNA signals linked with nervous system function, mental clarity, and sensory resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Neuro Health",
          "group": "Neuro Health",
          "badge": "DNA test, done once"
        },
        "Photosensitivity": {
          "copy": "Testing Photosensitivity helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Neuro Health",
          "group": "Neuro Health",
          "badge": "DNA test, done once"
        }
      }
    },
    "Physical Performance": {
      "Included DNA tests": {
        "Anaerobic Threshold": {
          "copy": "Testing Anaerobic Threshold helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Best Time of Day to Exercise": {
          "copy": "Testing Best Time of Day to Exercise helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Energy Recovery": {
          "copy": "Testing Energy Recovery helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Exercise Effect on Weight": {
          "copy": "Testing Exercise Effect on Weight helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Fasted vs Fed Exercise": {
          "copy": "Testing Fasted vs Fed Exercise helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Lean Body Mass": {
          "copy": "Testing Lean Body Mass helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Muscle Fibre Type": {
          "copy": "Testing Muscle Fibre Type helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Muscle Mass": {
          "copy": "Testing Muscle Mass helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Myostatin": {
          "copy": "Testing Myostatin helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        },
        "Stress": {
          "copy": "Testing Stress helps ENGNE read DNA signals linked with training response, energy recovery, muscle profile, and exercise timing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Physical Performance",
          "group": "Physical Performance",
          "badge": "DNA test, done once"
        }
      }
    },
    "Psychology": {
      "Included DNA tests": {
        "Anger": {
          "copy": "Testing Anger helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychology",
          "group": "Psychology",
          "badge": "DNA test, done once"
        },
        "Autism": {
          "copy": "Testing Autism helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychology",
          "group": "Psychology",
          "badge": "DNA test, done once"
        },
        "Brain Fog": {
          "copy": "Testing Brain Fog helps ENGNE read DNA signals linked with nervous system function, mental clarity, and sensory resilience. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychology",
          "group": "Psychology",
          "badge": "DNA test, done once"
        },
        "Intellect": {
          "copy": "Testing Intellect helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychology",
          "group": "Psychology",
          "badge": "DNA test, done once"
        },
        "Obsession": {
          "copy": "Testing Obsession helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychology",
          "group": "Psychology",
          "badge": "DNA test, done once"
        },
        "Optimism": {
          "copy": "Testing Optimism helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychology",
          "group": "Psychology",
          "badge": "DNA test, done once"
        },
        "Reward": {
          "copy": "Testing Reward helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychology",
          "group": "Psychology",
          "badge": "DNA test, done once"
        },
        "Warrior vs Worrier": {
          "copy": "Testing Warrior vs Worrier helps ENGNE read DNA signals linked with pressure response, motivation, mood patterns, and behavioural tendency. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Psychology",
          "group": "Psychology",
          "badge": "DNA test, done once"
        }
      }
    },
    "Skin": {
      "Included DNA tests": {
        "Dry Skin": {
          "copy": "Testing Dry Skin helps ENGNE read DNA signals linked with skin barrier strength, inflammatory response, and visible ageing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Skin",
          "group": "Skin",
          "badge": "DNA test, done once"
        },
        "Gluten Sensitivity": {
          "copy": "Testing Gluten Sensitivity helps ENGNE read DNA signals linked with digestive tolerance, immune response, and inflammatory sensitivity. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Skin",
          "group": "Skin",
          "badge": "DNA test, done once"
        },
        "Wrinkles": {
          "copy": "Testing Wrinkles helps ENGNE read DNA signals linked with skin barrier strength, inflammatory response, and visible ageing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Skin",
          "group": "Skin",
          "badge": "DNA test, done once"
        },
        "Rosacea": {
          "copy": "Testing Rosacea helps ENGNE read DNA signals linked with skin barrier strength, inflammatory response, and visible ageing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Skin",
          "group": "Skin",
          "badge": "DNA test, done once"
        },
        "Acne": {
          "copy": "Testing Acne helps ENGNE read DNA signals linked with skin barrier strength, inflammatory response, and visible ageing. It adds context for a more precise male health plan across training, nutrition, recovery, and long term resilience.",
          "area": "Skin",
          "group": "Skin",
          "badge": "DNA test, done once"
        }
      }
    },
    "Supplements": {
      "Included DNA tests": {
        "Ashwagandha": {
          "copy": "Testing Ashwagandha helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Curcumin": {
          "copy": "Testing Curcumin helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Essential Amino Acids": {
          "copy": "Testing Essential Amino Acids helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Epicatechin": {
          "copy": "Testing Epicatechin helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Ginger": {
          "copy": "Testing Ginger helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Glucosamine": {
          "copy": "Testing Glucosamine helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Glutamine": {
          "copy": "Testing Glutamine helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "HMB": {
          "copy": "Testing HMB helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Phosphatidic Acid": {
          "copy": "Testing Phosphatidic Acid helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Taurine": {
          "copy": "Testing Taurine helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Tribulus": {
          "copy": "Testing Tribulus helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Tyrosine": {
          "copy": "Testing Tyrosine helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for supplement response, recovery support, and performance nutrition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        },
        "Whey Protein Digestion": {
          "copy": "Testing Whey Protein Digestion helps ENGNE understand how your biology may respond to targeted supplementation. It adds context for fuel handling, appetite patterns, blood sugar balance, and body composition, so your plan can be more precise.",
          "area": "Supplements",
          "group": "Supplements",
          "badge": "DNA test, done once"
        }
      }
    },
    "Male Hormones": {
      "Included DNA tests": {
        "DHT & Prostate": {
          "copy": "Testing DHT & Prostate helps ENGNE interpret male hormone pathways linked with androgen activity, hormone balance, and male endocrine resilience. It adds context for training, recovery, metabolic health, and long term vitality.",
          "area": "Male Hormones",
          "group": "Male Hormones",
          "badge": "DNA test, done once"
        },
        "FSH Range": {
          "copy": "Testing FSH Range helps ENGNE interpret male hormone pathways linked with androgen activity, hormone balance, and male endocrine resilience. It adds context for training, recovery, metabolic health, and long term vitality.",
          "area": "Male Hormones",
          "group": "Male Hormones",
          "badge": "DNA test, done once"
        },
        "Oestrogen": {
          "copy": "Testing Oestrogen helps ENGNE interpret male hormone pathways linked with androgen activity, hormone balance, and male endocrine resilience. It adds context for training, recovery, metabolic health, and long term vitality.",
          "area": "Male Hormones",
          "group": "Male Hormones",
          "badge": "DNA test, done once"
        },
        "SHBG Range": {
          "copy": "Testing SHBG Range helps ENGNE interpret male hormone pathways linked with androgen activity, hormone balance, and male endocrine resilience. It adds context for training, recovery, metabolic health, and long term vitality.",
          "area": "Male Hormones",
          "group": "Male Hormones",
          "badge": "DNA test, done once"
        },
        "Testosterone": {
          "copy": "Testing Testosterone helps ENGNE interpret male hormone pathways linked with androgen activity, hormone balance, and male endocrine resilience. It adds context for training, recovery, metabolic health, and long term vitality.",
          "area": "Male Hormones",
          "group": "Male Hormones",
          "badge": "DNA test, done once"
        }
      }
    },
    "Epigenetics": {
      "Repeatable epigenetic tests": {
        "AlphaAge, Male Specific Biological DNA Methylation Test": {
          "copy": "Tracking AlphaAge, Male Specific Biological DNA Methylation Test helps ENGNE monitor methylation based signals linked with nutrient metabolism, methylation, energy support, and cellular function. It supports repeat testing as your biology changes across training, recovery, lifestyle, and age.",
          "area": "Epigenetics",
          "group": "Epigenetics",
          "badge": "Epigenetic test, repeatable"
        },
        "Memory Age": {
          "copy": "Tracking Memory Age helps ENGNE monitor methylation based signals linked with nervous system function, mental clarity, and sensory resilience. It supports repeat testing as your biology changes across training, recovery, lifestyle, and age.",
          "area": "Epigenetics",
          "group": "Epigenetics",
          "badge": "Epigenetic test, repeatable"
        },
        "Hearing Age": {
          "copy": "Tracking Hearing Age helps ENGNE monitor methylation based signals linked with biological age, methylation status, repair capacity, and long term resilience. It supports repeat testing as your biology changes across training, recovery, lifestyle, and age.",
          "area": "Epigenetics",
          "group": "Epigenetics",
          "badge": "Epigenetic test, repeatable"
        },
        "Eye Age": {
          "copy": "Tracking Eye Age helps ENGNE monitor methylation based signals linked with biological age, methylation status, repair capacity, and long term resilience. It supports repeat testing as your biology changes across training, recovery, lifestyle, and age.",
          "area": "Epigenetics",
          "group": "Epigenetics",
          "badge": "Epigenetic test, repeatable"
        },
        "Epi Vitality": {
          "copy": "Tracking Epi Vitality helps ENGNE monitor methylation based signals linked with biological age, methylation status, repair capacity, and long term resilience. It supports repeat testing as your biology changes across training, recovery, lifestyle, and age.",
          "area": "Epigenetics",
          "group": "Epigenetics",
          "badge": "Epigenetic test, repeatable"
        },
        "MethylGuard": {
          "copy": "Tracking MethylGuard helps ENGNE monitor methylation based signals linked with nutrient metabolism, methylation, energy support, and cellular function. It supports repeat testing as your biology changes across training, recovery, lifestyle, and age.",
          "area": "Epigenetics",
          "group": "Epigenetics",
          "badge": "Epigenetic test, repeatable"
        }
      }
    }
  }
};
